import { captureException } from 'sentry-error-logging!sofe';
import canopyUrls from 'canopy-urls!sofe';
import { DateTime } from 'luxon';
import { snakeCase } from 'lodash';

let isSet = false;
export default function userguidingAttributes() {
  try {
    if (!isSet) {
      isSet = true;
      userGuidingCustomAttributes();
    }
  } catch (e) {}
}

function hasLicense(license) {
  if (!Array.isArray(window.loggedInUser.licenses)) return false;
  return window.loggedInUser.licenses.includes(license);
}


async function userGuidingCustomAttributes() {
  let permissionAttributes = {};
  if (window?.loggedInUser?.permissions) {
    try {
      const res = await fetch(`${canopyUrls.getCDNUrl()}/permissions.json`);
      if (res.ok) {
        const { sections } = await res.json();
        sections.map(section => {
          permissionAttributes[`permission_group_${snakeCase(section.label)}`] =
            section.permissions.every(p => window.loggedInUser.permissions[p.name])
        });
      }
    } catch (e) {
      captureException(e);
    }
  }
  if (window.loggedInUser && window.tenant && window.userGuiding) {
    window.userGuiding.track('segment', {
      new_ui: window.loggedInUser.lastLogin < 1597104000000, // May 11th, 12am UTC
      new_user: window.loggedInUser.created_at > 1597104000000, // May 11th, 12am UTC
      contact_limit: window.tenant.contact_limit || 0,
      days_since_last_login: DateTime.fromMillis(window.loggedInUser.lastLogin)?.diffNow()?.days || 0,
      license_firm_management: hasLicense('firmManagement'),
      license_practice_management: hasLicense('practiceManagement'),
      license_practice_management_pro: hasLicense('practiceManagementPro'),
      license_client_management: hasLicense('clientManagement'),
      license_document_management: hasLicense('documentManagement'),
      license_time_and_billing: hasLicense('timeAndBilling'),
      license_workflow: hasLicense('workflow'),
      license_tax_resolution: hasLicense('taxResolution'),
      license_transcripts: hasLicense('transcripts'),
      license_notices: hasLicense('irsNotices'),
      ...permissionAttributes,
      role_sales: isRole(window.loggedInUser.email, 'sales'),
      role_success: isRole(window.loggedInUser.email, 'success'),
      role_support: isRole(window.loggedInUser.email, 'support'),
      role_sdr: isRole(window.loggedInUser.email, 'sdr'),
    });
    window.userGuiding.identify(window.loggedInUser.id, {
      name: window.loggedInUser.name,
      email: window.loggedInUser.email,
      accessLevel: window.loggedInUser.accessLevel,
    });
  }
}

function isRole(email, role) {
  const roles = {
    sales: [
      'jaren.mccormick@canopytax.com',
      'jono.daly@canopytax.com',
      'chris.wyss@canopytax.com',
      'austin.scott@canopytax.com',
      'michael.salmon@canopytax.com',
      'armin.kadic@canopytax.com',
      'will.fowler@canopytax.com',
    ],
    success: [
      'tiffany.timmermann@canopytax.com',
      'matt.gagon@canopytax.com',
      'daniel.douglas+12345@canopytax.com',
      'daniel.douglas@canopytax.com',
      'whitley.gordon@canopytax.com',
      'jeff.kinsel@canopytax.com',
      'Terrance.sherrell@canopytax.com',
      'keila.akers@canopytax.com',
    ],
    support: [
      'geoff.parker@canopytax.com',
      'emily.guaktier@canopytax.com',
      'sami.sherrell@canopytax.com',
      'lisa.knapp@canopytax.com',
      'reina.rodriguez@canopytax.com',
      'joelle.robinson@canopytax.com',
      'elliot.rose@canopytax.com',
      'brandon.woodward@canopytax.com',
    ],
    sdr: [
      'jake.godfrey@getcanopy.com',
      'cade.downs@getcanopy.com',
      'collin.gibb@getcanopy.com',
      'daniel.ruales@getcanopy.com',
      'mckade.hunter@getcanopy.com',
      'sadie.hunter@getcanopy.com',
      'skyler.ebreo@getcanopy.com',
      'jacob.curtis@getcanopy.com',
      'kyle.starr@getcanopy.com',
    ],
  };
  return roles[role].includes(email);
}
